.loadingSpinner {
  color: var(--ixf-text-tone-md);

  @keyframes loading-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  & {
    animation: loading-spinner 800ms linear infinite;
  }

  path {
    color: var(--ixf-text-tone-md);
    stroke: var(--ixf-text-tone-md);
  }
}
